"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformClientAnnotationToBffInput = void 0;
var tslib_1 = require("tslib");
var transformClientAnnotationToBffInput = function (annotation) {
    return Object.entries(annotation)
        .filter(function (_a) {
        var _b = tslib_1.__read(_a, 2), _ = _b[0], value = _b[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
        if (key === 'swapPlan' && typeof value === 'object') {
            value = JSON.stringify(value);
        }
        return {
            key: key,
            value: String(value),
        };
    });
};
exports.transformClientAnnotationToBffInput = transformClientAnnotationToBffInput;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformClientAnnotationToBffInput.js
// module id = 1333
// module chunks = 11